module.exports = __webpack_public_path__ + "img/hud_left_top_corn.b01a1ff5.png";